<app-data-grid-comp
    [category]="category"
    [gridId]="gridId"
    [columns]="columns"
    [filterCategories]="filterCategories"
    [gridDataResult]="gridDataResult"
    [pageSize]="pageSize"
    [skip]="skip"
    [clearSelectedItems]="clearSelectedItems"
    hideActionButtons="true"
    [rowSelectionSettings]="{
        canSelectRows: false,
        selectableMode: 'multiple',
        selectRowBy: 'id'
    }"
    clickableRows="true"
    [isLoading]="isLoading"
    searchable="true"
    showRefreshButton="true"
    (emitRefreshEvent)="getBuySellPlanEmployees()"
    [sortable]="{
        mode: 'multiple'
    }"
    [sortableColumns]="sortableColumns"
    (emitOpenDialogEvent)="openDialog($event)"
    (emitGridStateChangeEvent)="gridStateChange($event)"
></app-data-grid-comp>